import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexFlow: 'column wrap',
    overflow: 'hidden'
  }
}));

const KeepMounted = ({ isMounted, render, componentHasBeenMounted, setComponentHasBeenMounted }) => {
  const classes = useStyles();
  useEffect(() => {
    setComponentHasBeenMounted(componentHasBeenMounted || isMounted);
  }, [isMounted]);
  return (
    <div style={{ display: isMounted ? null : 'none' }} className={classes.container}>
      { componentHasBeenMounted ? render() : null }
    </div>
  );
}

export default KeepMounted; 